import React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";
import { ProductConfiguratorComponent } from "components/_ProductConfigurator";

export const ProductConfigurator = Scrivito.connect(() => (
  <ProductConfiguratorComponent />
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProductConfigurator {...props} />
  </ObjValidator>
);

export default CheckedPage;
Scrivito.provideComponent("ProductConfigurator", CheckedPage);
